import { ReactNode, useState } from "react";
import { Button } from "../Button";

type LayeredButtonProps = {
  leftLabel: string;
  leftButtonLeftIcon?: ReactNode;
  leftButtonRightIcon?: ReactNode;
  leftOnClick(): void;
  rightLabel: string;
  rightButtonLeftIcon?: ReactNode;
  rightButtonRightIcon?: ReactNode;
  rightOnClick(): void;
  isMobileView?: boolean;
};
export const LayeredButton = ({
  leftLabel,
  leftButtonLeftIcon = undefined,
  leftButtonRightIcon = undefined,
  leftOnClick,
  rightLabel,
  rightButtonLeftIcon = undefined,
  rightButtonRightIcon = undefined,
  rightOnClick,
  isMobileView = false,
}: LayeredButtonProps) => {
  const [addHoverClass, setAddHoverClass] = useState(true);
  const hoverClassName = addHoverClass ? " hover:bg-secondary-100" : "";
  const spacing = isMobileView ? "tight-hug" : "hug";

  const handleMouseOver = () => {
    setAddHoverClass(false);
  };

  const handleMouseLeave = () => {
    setAddHoverClass(true);
  };

  return (
    <div>
      <div
        className={`flex bg-primary-500 ${hoverClassName} rounded-full active:bg-primary-600`}
      >
        <Button
          buttonStyle="primary"
          fill="outline"
          leftIcon={leftButtonLeftIcon}
          rightIcon={leftButtonRightIcon}
          spacing={spacing}
          onClick={leftOnClick}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
        >
          {leftLabel}
        </Button>
        <Button
          buttonStyle="transparent"
          fill="link"
          leftIcon={rightButtonLeftIcon}
          rightIcon={rightButtonRightIcon}
          spacing={spacing}
          onClick={rightOnClick}
        >
          {rightLabel}
        </Button>
      </div>
    </div>
  );
};

export default {};
